<template>
  <div>
    <table class="rm-table">
      <thead>
      <th>ID</th>
      <th>Name</th>
      <th>Description</th>
      </thead>
      <tbody>
      <tr v-for="requirement in selectedRequirements">
        <td>{{requirement.prefix}}{{requirement.display_id ? requirement.display_id : requirement.requirement_id}}</td>
        <td>{{requirement.name}}</td>
        <td><span class="description">{{requirement.description}}</span></td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
  import utilsMixin from '@/mixins/utils'
  export default {
    data () {
      return {
        selectedRequirements: []
      }
    },
    created () {
      this.getIdsFromMacro()
    },
    mixins: [utilsMixin],
    methods: {
      getIdsFromMacro () {
        window.AP.require('request', request => {
          const pageId = this.getUrlParam('pageId')
          const pageVersion = this.getUrlParam('pageVersion')
          const macroId = this.getUrlParam('macroId')
          request({
            url: '/rest/api/content/' + pageId +
              '/history/' + pageVersion +
              '/macro/id/' + macroId,
            success: response => {
              const macro = JSON.parse(response)
              const requirementIds = macro.parameters.requirementIds.value.split(',').map(s => Number(s))
              this.getLinkedRequirements(requirementIds)
            }
          })
        })
      },
      getUrlVars () {
        const vars = {}
        window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function (m, key, value) {
          vars[key] = value
        })
        return vars
      },
      getUrlParam (parameter, defaultvalue) {
        let urlparameter = defaultvalue
        if (window.location.href.indexOf(parameter) > -1) {
          urlparameter = this.getUrlVars()[parameter]
        }
        return urlparameter
      },
      getLinkedRequirements (requirementIds) {
        this.$http.post(
          '/api/requirement/by-id/lite',
          {'requirementIds': requirementIds}
        ).then(response => {
          this.selectedRequirements = response.data.requirements
        }, response => {
          console.log('error')
        })
      }
    }
  }
</script>

<style scoped>
  .description {
    white-space: pre-wrap;
  }
</style>



// WEBPACK FOOTER //
// ConfluenceInsertRequirementsMacroView.vue?1c5686f2